import { getFetchSuggestionChatEndpointQueryKey } from '@lotushealth/lotushealth_js_sdk/endpoints';

import { ENV } from '@/shared/config';

import { getAccessToken } from './client';

export function getHostageChatUrl(userId: string): string {
  return `${ENV.apiBaseUrl}/greenfield/care/${userId}/hostage/chat`;
}

export function getSuggestionChatUrl(userId: string, actionId: string): string {
  const [path] = getFetchSuggestionChatEndpointQueryKey(userId, actionId);
  return `${ENV.apiBaseUrl}${path}`;
}

export async function createLotusAuthHeadersOptional(): Promise<Record<string, string>> {
  const token = await getAccessToken();
  return token ? { Authorization: `Bearer firebase:${token}` } : {};
}
